
















import Vue, { PropOptions } from "vue";
import { GemmaError } from "@gemma/errors";
import { IsApiResponse } from "@gemma/api-common";
import "./scss";

export default Vue.extend({
  name: "SaveSetting",
  props: {
    save: Boolean,
    path: {
      type: String,
      default: undefined,
    } as PropOptions<string>,
    value: ({
      type: null,
      default: undefined,
    } as unknown) as PropOptions<any>,
    route: {
      type: String,
      required: true,
    } as PropOptions<string>,
  },
  data() {
    return {
      errors: false,
      saving: false,
      saved: false,
      showOverlay: false,
    };
  },
  watch: {
    async save(newValue) {
      if (newValue) {
        this.showOverlay = true;
        this.$emit("clearErrors");
        this.saved = false;
        setTimeout(() => {
          if (this.saved || this.errors) {
            this.saving = false;
          } else {
            this.saving = true;
          }
        }, 250);

        try {
          const apiResult = await this.$app.api.patch<{ path: string; value: unknown }, unknown, undefined>(this.route, { path: this.path, value: this.value });
          if (IsApiResponse(apiResult)) {
            this.errors = true;
            this.$emit("errors", apiResult.meta.errors);
            this.showOverlay = false;
          } else {
            this.saved = true;
            this.$emit("saved", apiResult);
            setTimeout(() => {
              this.saved = false;
              this.showOverlay = false;
            }, 500);
          }
        } catch (error) {
          this.errors = true;
          this.$emit("errors", [new GemmaError((error as Error).message, { innerError: error as Error })]);
          this.showOverlay = false;
        } finally {
          this.saving = false;
        }
      }
    },
  },
});
